import * as _ from 'lodash'
import * as moment from 'moment'
import { parseFormattedNumber } from '../..';

/**
 * Returns all HTMLInputElements with names
 * @param form
 */
const getInputsWithNameAndValue = (form: HTMLFormElement) => {
  const inputs: HTMLInputElement[] = []

  for (let i = 0; i <= form.elements.length; i++) {
    const element = form.elements[i]

    if (element instanceof HTMLInputElement && element.name) {
      if (element.type === 'radio' && !element.checked) {
        continue //do not grab non-checked radio inputs
      }

      inputs.push(element)
    }
  }

  return inputs
}

/**
 * A form helper to parse form's data
 */
class FormParser {

  /**
   * Given a form with inputs that contain names with pathExpressions
   * return a an object composed of those paths.
   * @param form
   */
  static parseInputsWithPaths<T>(form: HTMLFormElement, modifyName?: (name: string) => string, obj?: T): T {
    // tslint:disable-next-line:no-debugger
    //debugger
    // tslint:disable-next-line:no-object-literal-type-assertion
    obj = obj || {} as T
    const inputs = getInputsWithNameAndValue(form)
    const hasModifyName = typeof modifyName === 'function'

    if (inputs.length <= 0) { return null }

    inputs.forEach(({ type, name, value, checked, accept }) => {
      let valueAny: any = value
      const isNumber = value && !isNaN(parseFormattedNumber(value))
      const isDuration = accept === 'text/duration-years'
      name = hasModifyName ? modifyName(name) : name

      if (value === '') {
        _.unset(obj, name)
        return
      }

      if (isDuration) {
        valueAny = value ? moment.duration(value) : null
      } else if (type === 'checkbox') {
        valueAny = checked //sets value to true/false for checkboxes
      } else if (isNumber) {
        valueAny = parseFormattedNumber(value)
      }

      _.set(obj, name, valueAny)
    })

    return obj
  }
}

export {
  FormParser
}



// WEBPACK FOOTER //
// ./src/app/utils/form/parser/index.ts